const mapStateToProps = (state) => ({
  step: state.solicitudEmpadronamiento.step,
});

export default mapStateToProps;
